import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

export enum PushConnectorsEnum {
  SOCKET_IO = 'socket.io',
  PUSHER = 'pusher',
  ABLY = 'ably',
}

export const RPusherConfig = t.type({
  connector: t.literal(PushConnectorsEnum.PUSHER),
  key: t.string,
  cluster: t.string,
  roomsPrefix: t.string,
  ably: t.type({
    environment: t.string,
  }),
});

export const RAblyConfig = t.type({
  connector: t.literal(PushConnectorsEnum.ABLY),
  roomsPrefix: t.string,
  environment: t.string,
});

const RSocketIOConfig = t.type({
  connector: t.literal(PushConnectorsEnum.SOCKET_IO),
});

const RORPusherConfig = t.readonly(RPusherConfig);
const RORAblyConfig = t.readonly(RAblyConfig);
const RORSockerIOConfig = t.readonly(RSocketIOConfig);
const RPushConfigDirty = t.readonly(
  t.taggedUnion('connector', [RPusherConfig, RSocketIOConfig, RAblyConfig]),
);

/*
 * Type.
 */

export interface PusherConfigModel extends t.TypeOf<typeof RORPusherConfig> {}
export interface AblyConfigModel extends t.TypeOf<typeof RORAblyConfig> {}
export interface SocketIOConfigModel extends t.TypeOf<typeof RORSockerIOConfig> {}
export type PushConfigModel = PusherConfigModel | AblyConfigModel | SocketIOConfigModel;

export const RPushConfig = t.clean<PushConfigModel>(RPushConfigDirty as any);
export const RCPushConfig = t.clean<PusherConfigModel>(RORPusherConfig as any);

/*
 * IO methods.
 */

export function parsePushConfigModel(src: any): PushConfigModel {
  const {connector} = src;

  if (connector === PushConnectorsEnum.ABLY) {
    return parseAblyConfigModel(src);
  }

  if (connector === PushConnectorsEnum.PUSHER) {
    return parsePusherConfigModel(src);
  }

  return {connector};
}

export function parseAblyConfigModel(src: any): AblyConfigModel {
  return {
    connector: PushConnectorsEnum.ABLY,
    roomsPrefix: src.rooms_prefix || '',
    environment: src.ably?.environment || src.environment || '',
  };
}

export function parsePusherConfigModel(src: any): PusherConfigModel {
  return {
    connector: PushConnectorsEnum.PUSHER,
    key: src.pusherKey,
    cluster: src.cluster,
    roomsPrefix: src.rooms_prefix || '',
    ably: {
      environment: src.ably?.environment || '',
    },
  };
}

/*
 * API type.
 */

export const ApiPushConfig = makeApiType('pushConfigModel', RPushConfig, parsePushConfigModel);
